module.exports = __webpack_public_path__ + "media/images/yardage_mark_1-20ea18f17fff38503526d49b192a60ef.png";